(() => {
    'use strict';

    if (!real.dom.$body.hasClass('validate-login-link')) {
        return;
    }

    $('.send-btn').on('click', e => {
        const btn = $(e.currentTarget);
        const errorElem = $('.pin-send-error');
        const alreadySentElem = $('.pin-already-sent');
        real.button.loading(btn);
        errorElem.text('');
        alreadySentElem.text('');

        const showPinEntry = () => {
            $('.pin-send').addClass('d-none');
            $('.pin-entry').removeClass('d-none');
            $('.howspace-form-otp-input .howspace-form-number-input')[0]?.focus();
        };

        real.ajax.json(real.baseUri + '/sessions/send-pin/' + btn.data('login-link-uid'), {
            type : 'POST',
            waitForWebsocket : false,
            showErrorNotification : false,
            logError : response => {
                return response.status !== 403;
            },
            success : showPinEntry,
            error : response => {
                // The current PIN still works, so let the user enter it instead of waiting for a new one.
                if (real.ajax.hasErrorKey(response, 'pin_already_sent')) {
                    real.ajax.loopErrors(response, error => {
                        alreadySentElem.text(error.message);
                    });
                    showPinEntry();
                    return;
                }

                // The page has no notification area, so the error is shown next to the button.
                real.ajax.loopErrors(response, error => {
                    errorElem.text(error.message);
                });
            },
            complete : () => {
                real.button.reset(btn);

                // The disabled button lost focus while loading, so put it back when the user stays on this step.
                if (!$('.pin-send').hasClass('d-none')) {
                    btn.trigger('focus');
                }
            }
        });
    });

    $('.resend-btn').on('click', () => {
        $('.pin-already-sent').text('');
        $('.pin-send').removeClass('d-none');
        $('.pin-entry').addClass('d-none');
        howspace.components.otpInput.reset($('.howspace-form-otp-input'));
    });
})();
